module.exports = __webpack_public_path__ + "img/pagarme.6ae68f04.svg";